import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { CreateTicketModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/support-service-lib/src/wrapper/inputs/create-ticket.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useUpdateTicketContext } from '../../ticket.context';
import { TicketUpdateFormStep1Controller } from '../ticket-update-form-step-1/ticket-update-form-step-1.controller';

export interface TicketUpdateFormControllerProps {
  onError: SubmitErrorHandler<CreateTicketModel>;
  onSubmit: SubmitHandlerWithDirtyFields<CreateTicketModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const TicketUpdateFormController = ({
  onError,
  onSubmit,
  onCancel,
  state,
}: TicketUpdateFormControllerProps): React.JSX.Element => {
  const { id, ...defaultValues } = useUpdateTicketContext();

  return (
    <MultiStepFormProvider<CreateTicketModel>
      useFormProps={{
        mode: 'all',
        defaultValues,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['title', 'description', 'assigneeId'],
          component: <TicketUpdateFormStep1Controller />,
        },
      ]}
    />
  );
};
